const $ = require('./js/plugins/jquery.min');
global.$ = global.jQuery = $;
require('./js/src/modules');
require('./js/plugins/jquery.validate.min');
require('./js/plugins/jquery.inputmask.min.js');
global.io = require('./js/plugins/socket.io.min.js');
require('./js/src/burger');
require('./js/src/select');
require('./js/src/range');
require('./js/src/checkbox');
require('./js/src/accordion');
require('./js/src/mask');
require('./js/src/popups');
require('./js/src/ajax');
require('./js/src/validation');
require('./js/src/favorites');
require('./js/src/main');
require('./js/src/preloader');
require('./js/src/search');
require('./js/src/maps/search');
require('./js/src/load_maps');
require('./js/src/socket');
require('./js/src/notifications');
require('./js/src/footer_details');
require('./js/src/shares');
require('./js/src/ajax_popups');
require('./js/src/lazy');
require('./js/src/show_map_btn');
require('./js/src/download_pdf');
require('./js/src/captcha');

global.initFiltersForm = initFiltersForm;
global.filtersFormData = new FormData($('#search').get()[0]);

function initFiltersForm() {
  var container = $('.filter-overlay');
  var form = $('#search');
  form.off('reset').on('reset', function() {
    makeQuery(global.filtersFormData);
  })
  function makeQuery(formData, setActive) {
    $.ajax('/listing/filter_options', {
      method: 'POST',
      data: formData,
      context: container.find('.filter-settings .inputs_container'),
      success: function(data) {
        var newForm = $(data);
        if(setActive) {
          newForm.addClass('active')
        }
        var newFormHtml = newForm.get()[0];
        setTimeout(function() {
          container.replaceWith(newFormHtml);
          global.modules.init(newFormHtml);
          global.initFiltersForm();
          // global.initPopUp(newFormHtml);
        }, 320)
      }
    })
  }
  container.find('[name]').on('change', function() {
    if($(this).closest('.no_reload').length) {
      return;
    }
    var formData = new FormData(form.get()[0]);
    makeQuery(formData, true)
  })
}

jQuery(function() {
  initFiltersForm();
  global.modules.init();
  $('.list-question').accordion();
})

require('./css/basic.css');
require('./css/footer.css');
require('./css/header.css');
require('./css/normalize.css');
require('./css/style-bundle.css');
require('./css/listing.css');
require('./css/message.css');
require('./css/main-page.css');
require('./css/temp.css');
require('./js/plugins/datepicker/datepicker.min.css');